import React from 'react'
import { Link, Icon, Box } from '@ally/metronome-ui'
import { muiPaperlessLeaf } from '@ally/metronome-icons'
import styled from 'styled-components'
import { AcctDetailsItem, Dd, Dt } from './StyledDlElements'
import { NonPrintingWrapper } from '../../../utils/NonPrintingWrapper'
import { useCustomer } from '../../../hooks/use-customer'

const StyledIcon = styled(Icon)`
  display: inline;
`
const GoPaperless = styled.div`
  display: inline;
`

export const GoPaperlessDl: React.FC = () => {
  const { hasPaperDelivery } = useCustomer()

  if (!hasPaperDelivery()) return <></>

  return (
    <NonPrintingWrapper>
      <AcctDetailsItem>
        <Dt>
          <Link
            to="/profile/paperless-settings"
            unsupportedContent={
              <Box width="400px">
                <StyledIcon aria-hidden="true" icon={muiPaperlessLeaf} />
                {` `}
                <GoPaperless>Go Paperless</GoPaperless>
              </Box>
            }
          />
        </Dt>
        <Dd />
      </AcctDetailsItem>
    </NonPrintingWrapper>
  )
}
